/**
 * Returns true iff the loaded save string represents the official current
 * state of the league — the only situation where the picker should overlay
 * IRL playoff outcomes onto the bracket.
 *
 * Used by NHL and NBA schedule-pickers from inside their UrlString
 * subscribers. Loads from `?L=`, localStorage, or watchlists carry the
 * user's own picks; if those differ from CurrentSeasonString, applying
 * the overlay would clobber the user's playoff modifications.
 */
export function shouldApplyOfficialOverlay(
  loadedSaveString: string,
  currentSeasonString: string
): boolean {
  if (!loadedSaveString || !currentSeasonString) {
    return false;
  }
  return loadedSaveString === currentSeasonString;
}
